import { motion } from "framer-motion";
import { Check, Globe } from "lucide-react";
import { IMAGES } from "@/lib/site";

const features = [
  "Réseau de 500+ fournisseurs vérifiés",
  "Vérification qualité à chaque étape",
  "Tarifs compétitifs garantis",
  "Support multilingue 24/7",
  "Délais de livraison optimisés",
  "Transparence totale des coûts",
];

const hubs = [
  { flag: "🇨🇳", country: "Chine", cities: "Shanghai, Beijing" },
  { flag: "🇰🇷", country: "Corée", cities: "Séoul, Busan" },
];

export const About = () => {
  return (
    <section id="apropos" className="bg-slate-50 py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-5 sm:px-8 grid lg:grid-cols-2 gap-14 items-center">
        <motion.div
          initial={{ opacity: 0, x: -20 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <p className="text-xs font-bold tracking-[0.25em] uppercase text-brand-gold mb-4 flex items-center gap-2">
            <Globe size={14} /> À propos de nous
          </p>
          <h2 className="font-display font-bold uppercase tracking-tight leading-none text-brand-navy text-4xl sm:text-5xl">
            Votre partenaire de confiance en Asie
          </h2>
          <p className="mt-6 text-slate-600 text-base lg:text-lg leading-relaxed">
            Depuis plusieurs années, King of Sourcing aide les entreprises à naviguer la complexité
            du sourcing international. Nous combinons expertise locale, technologie moderne et un
            service client exceptionnel.
          </p>

          <div className="mt-8 grid sm:grid-cols-2 gap-x-6 gap-y-3">
            {features.map((f) => (
              <div key={f} className="flex items-start gap-3" data-testid={`about-feature-${f.slice(0, 6)}`}>
                <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-brand-navy text-white">
                  <Check size={13} />
                </span>
                <span className="text-sm text-slate-700">{f}</span>
              </div>
            ))}
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="relative"
        >
          <div className="overflow-hidden rounded-lg bg-white border border-black/5 p-3">
            <img src={IMAGES.meeting} alt="Réseau logistique mondial King of Sourcing depuis la Chine et la Corée" className="w-full h-auto object-contain" />
          </div>
          <div className="mt-4 grid grid-cols-2 gap-4">
            {hubs.map((h) => (
              <div key={h.country} className="rounded-lg bg-brand-navy p-5 text-white" data-testid={`hub-${h.country}`}>
                <p className="text-3xl leading-none">{h.flag}</p>
                <p className="font-display font-semibold text-xl mt-3">{h.country}</p>
                <p className="text-xs text-white/60 mt-1">{h.cities}</p>
              </div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
};
